import { useCallback } from "react";
import useGtagEvents from "../../gtag/hooks/use-gtag-events";
import { USER_MODULE_ACTION, useUserModuleDispatch } from "../../user";
import useUser from "../../user/hooks/use-user";

export default function useCompleteGame() {
    const dispatch = useUserModuleDispatch();
    const { gameCompleted } = useUser();
    const { sendGameCompleted } = useGtagEvents();

    const setCompleteGame = useCallback((value: boolean) => {
        dispatch({
            type: USER_MODULE_ACTION.SET_COMPLETE_GAME,
            payload: {
                value
            }
        })
    }, [dispatch]);

    const completeGame = useCallback(() => {
        if (!gameCompleted) {
            sendGameCompleted();
            setCompleteGame(true);
        }
    }, [sendGameCompleted, setCompleteGame, gameCompleted]);

    return {
        completeGame,
        setCompleteGame,
        isGameComplete: gameCompleted
    }
}
